import Close16 from '@carbon/icons-react/es/close/16';
import React from 'react';
import styled from 'styled-components';
import {
  CustomLayoutDrawer,
  CustomLayoutDrawerContent as DrawerContent,
} from 'components/atoms/drawer';
import { BodyShort01, Label01 } from 'components/styles';

const drawerWidth = 680;

export const Drawer = styled(CustomLayoutDrawer).attrs({
  width: drawerWidth,
  placement: 'right',
  closable: true,
  closeIcon: <Close16 />,
  mask: true,
  destroyOnClose: true,
})`
  z-index: var(--zindex-layer-09);
  .ant-drawer-body {
    padding: 0;
    ${DrawerContent} {
      width: ${drawerWidth}px;
    }
    ${DrawerContent.Content} {
      display: flex;
      flex-direction: column;
    }
    ${DrawerContent.Footer} {
      text-align: right;
    }
  }
`;
export const UserOrTeamAvatarRow = styled.div`
  padding: var(--spacing-03);
`;
export const AllocationDetailRow = styled.div`
  padding: var(--spacing-06) var(--spacing-03);
  display: flex;
  gap: calc(var(--layout-01) + var(--layout-05));
`;

export const AllocationDetailLabel = styled.div`
  ${Label01};
  color: var(--gray-80);
`;
export const AllocationDetailValueWrapper = styled.div`
  ${BodyShort01};
  color: var(--gray-100);
  display: flex;
  gap: var(--spacing-02);
`;
export const AllocationDetailSecondaryValue = styled.div`
  color: var(--gray-50);
  display: flex;
  gap: var(--spacing-02);
`;
export const AllocationDetail = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-02);
`;
export const GridContainer = styled.div`
  height: 100%;
  width: 100%;
  position: relative;
  .ag-react-container {
    width: 100%;
    > :not(:first-child) {
      display: none !important;
    }
    > div {
      width: 100%;
    }
  }
  .ag-row {
    cursor: pointer;
    border-bottom: 1px solid var(--table-border-color);
  }
  .ag-row-odd {
    background-color: var(--ag-background-color, var(--white-100));
    &.ag-row-focus {
      background: var(--ag-row-hover-color);
    }
  }
`;

export const Overlay = styled.div`
  position: absolute;
  display: flex;
  top: 32px;
  left: 0;
  right: 0;
  z-index: var(--zindex-layer-03) !important;
  justify-content: center;
`;

export const LoadingOverlay = styled(Overlay)`
  flex-direction: column;
  flex: 1 1 100%;
`;
